enum DateFormat {
  Iso8601 = 'YYYY-MM-DD',
  Iso8601WithTime = 'YYYY-MM-DD HH:mm:ss',
  ShortMonthDay = 'MMM DD',
  /**a.k.a `DISPLAY_FORMAT` */
  NumericMonthDayYear = 'MM/DD/YYYY',
  NumericMonthDayYearTime = 'MM/DD/YYYY h:mm a',
  LongMonthYear = 'MMMM YYYY',
  DayShortMonthYear = 'D MMM, YYYY',
  LongTime = 'LT',
  LongMonth = 'MMMM',
  ShortMonth = 'MMM',
  PaddedDay = 'DD',
  DayLongMonthYear = 'D MMMM, YYYY',
}

export default DateFormat;
